// Admin Sidebar Configuration
// Centralized sidebar items for all admin pages

export interface AdminSidebarItem {
  key: string;
  label: string;
  icon?: string;
  route: string;
}

export const ADMIN_SIDEBAR_ITEMS: AdminSidebarItem[] = [
  { key: 'dashboard', label: 'Dashboard', route: '/admin/dashboard' },
  { key: 'nodes', label: 'Nodes', route: '/admin/nodes' },
  { key: 'ads', label: 'Ads Manager', route: '/admin/ads' },
  { key: 'lookal-internal-ads', label: 'LooKal Internal Ads', route: '/admin/lookal-internal-ads' },
  { key: 'campaign-approval', label: 'Campaign Approval', route: '/admin/campaign-approval' },
  { key: 'qrcodes', label: 'QR Codes', route: '/admin/qrcodes' },
  { key: 'notifications', label: 'Notifications', route: '/admin/notifications' },
  { key: 'smart-tips', label: 'Smart Tips', route: '/admin/smart-tips' },
  { key: 'credit-bonus', label: 'Credit Bonus Tiers', route: '/admin/credit-bonus-tiers' },
  { key: 'slot-tiers', label: 'Slot Tiers & Pricing', route: '/admin/slot-tiers' },
  { key: 'configuration', label: 'Configuration Management', route: '/admin/configuration' },
  { key: 'reports', label: 'Reports', route: '/admin/reports' },
  { key: 'logs', label: 'System Logs', route: '/admin/logs' },
  { key: 'tv-display-logs', label: 'TV Display Logs', route: '/admin/tv-display-logs' },
  { key: 'settings', label: 'Settings', route: '/admin/settings' },
  { key: 'licensing-approvals', label: 'Licensing Approvals', route: '/admin/licensing-approvals' },
  { key: 'licensing-monitor', label: 'Licensing Monitor', route: '/admin/licensing-monitor' },
  { key: 'ml-invitations', label: 'ML Invitations', route: '/admin/ml-invitations' },
  { key: 'agreement-templates', label: 'Agreement Templates', route: '/admin/agreement-templates' },
  { key: 'payout-review', label: 'Payout Review', route: '/admin/payout-review' },
  { key: 'settlement-batches', label: 'Settlement Batches', route: '/admin/settlement-batches' },
  { key: 'ota-updates', label: 'OTA Updates', route: '/admin/ota-updates' },
  { key: 'roles-permissions', label: 'Roles & Permissions', route: '/admin/roles-permissions' },
];
